import React from 'react';
import {Space} from 'antd';
import {Text} from "../styled/Text";
import {Flex} from "../styled/Flex";
import {HorizontalLayout} from "../../layout/HorizontalLayout";
import {faSync} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface TitleHeaderInterface {
    title: string;
    icon: React.ReactElement;
    marginTop?: string;
    marginBottom?: string;
    color?: string;
    fontWeight?: string;
    fontSize?: string;
    actionIcon?: React.ReactElement;
    actionHandler?: () => void;
    additionalAction?: React.ReactElement;
}
const voidFunc = () => {};

const TitleHeader: React.FC<TitleHeaderInterface> = (props) => {
    const marginBottom = props.marginBottom ?? '20px';
    const marginTop = props.marginTop ?? '0px';
    const color = props.color ?? '#1890ff';
    const fontWeight = props.fontWeight ?? '700';
    const actionIcon = props.actionIcon ?? <FontAwesomeIcon icon={faSync} color={props.color}/>;
    const actionHandler = props.actionHandler ?? voidFunc;

    const style = {
        marginBottom: marginBottom,
        marginTop: marginTop
    }
    return (
        <HorizontalLayout style={{...style}}>
            <Text
                fontSize={props.fontSize}
                fontWeight={fontWeight}
                color={color}
            >
                <span>{props.icon}</span>  {props.title}
            </Text>
            <Flex direction={'row'}>
                <Space size={20}>
                    {props.additionalAction}
                    {(props.actionHandler !== undefined) && <Text style={{cursor: 'pointer'}} onClick={()=> {actionHandler()}}>{actionIcon}</Text>}
                </Space>
            </Flex>
        </HorizontalLayout>
    )
};

export default TitleHeader;